export const AGGREGATED_CART_DATA = 'AGGREGATED_CART_DATA';
